import './LoadingState.scss';

import React from 'react';
import Spin from 'antd/es/spin';

interface LoadingStateProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ size = 'large' }) => {
  return (
    <div className="loading-state-container">
      <Spin size={size} />
    </div>
  );
};
